export const MAXIMUM_NUMBER_OF_CREDITS_PER_RESPONDENT = 10;
export const MINIMU_NUMBER_OF_CREDITS_PER_RESPONDENT = 4;
export const MAXIMUM_NUMBER_OF_CREDITS_FOR_IBS = 3;
